// Browser telemetry (OpenObserve RUM + session replay) drops cookies and records
// the screen, so it requires prior consent under RODO/ePrivacy. It is therefore
// NOT started here on load — the CookieConsent component owns the gate and calls
// initRum() only after the visitor accepts the "analytics" category. See
// `src/otel/rum-client.ts` and `src/components/CookieConsent`.
export {}
